module.exports = __webpack_public_path__ + "assets/icons/ic_person_24px.svg";